<div class="app-update-stock-count-responsive p-g-12">
   <app-confirm-dialog
      [visible]="confirmationDialogVisible"
      variant="secondary"
      heading="Confirmation"
      message="Are you sure you want to Update Inventory Count?"
      cancelText="No"
      (confirmed)="confirmConfirmationDialog()"
      (cancelled)="cancelConfirmationDialog()">
   </app-confirm-dialog>
   <div class="p-g-12">

      <div class="p-g">

         <div class="p-g-12 p-table-tecfolk-fix">

            <p-table [value]="products" [paginator]="true" [rows]="20" [responsive]="true" [loading]="loading"
               [first]="first" (onPage)="onPageChange($event)">

               <ng-template pTemplate="caption" style="text-align: left">
                  <div class="reportMainBtn">
                     <app-action-button
                        variant="secondary"
                         size="sm"
                        text="{{ setLabel('updateBtnLabel') || 'Update' }}"
                        title="{{ setLabel('updateQuantityTooltipLabel') || 'Update Quantity' }}"
                        ariaLabel="{{ setLabel('updateBtnLabel') || 'Update' }}"
                        [disabled]="loading || !isData"
                        (action)="updateInventoryCount()">
                     </app-action-button>
                  </div>
               </ng-template>

               <ng-template pTemplate="header">
                  <tr>
                     <th style="max-width: 90px;">{{setLabel("codeLabel")}}</th>
                     <th style="max-width: 90px;">{{setLabel("imageLabel")}}</th>
                     <th style="max-width: 90px;">{{setLabel("itemLabel")}}</th>
                     <th style="max-width: 130px;">{{setLabel("quantityLabel")}}</th>
                     <th style="max-width: 130px;">{{setLabel("countedQuantityLabel")}}</th>
                  </tr>
               </ng-template>

               <ng-template pTemplate="body" let-rowData>
                  <tr>
                     <td class="mobile-td">
                        <div class="mobile-lable">
                           {{setLabel("codeLabel")}}
                        </div>
                        <div>
                           {{rowData.code}}
                        </div>
                     </td>
                     <td class="mobile-td">
                        <div class="mobile-lable" style="align-items: center; display: flex;">
                           {{setLabel("imageLabel")}}
                        </div>
                        <div>
                           <a (click)="openPhoto(rowData.imagePath)">
                              <img [alt]="" src="{{rowData.imagePath}}" width="60" style="vertical-align: middle" />
                           </a>
                        </div>

                     </td>
                     <td class="mobile-td">
                        <div class="mobile-lable">
                           {{setLabel("itemLabel")}}
                        </div>
                        <div>
                           {{rowData.name}}
                        </div>

                     </td>
                     <td class="mobile-td">


                        <div class="mobile-lable">
                           {{setLabel("quantityLabel")}}
                        </div>
                        <div>
                           {{rowData.totalQuantity}}
                        </div>
                     </td>
                     <td class="mobile-td">
                        <div class="mobile-lable">
                           {{setLabel("countedQuantityLabel")}}
                        </div>
                        <div>
                           <input style="width: 50%;" pinputtext="" autocomplete="off" type="number"
                              name="countedQunatity" class="p-corner-all p-state-default p-widget"
                              [(ngModel)]="rowData.countedQunatity" oninput="this.value = Math.max(0, this.value);">
                        </div>
                     </td>
                  </tr>
               </ng-template>
            </p-table>
         </div>
      </div>
   </div>

   <div *ngIf="imgPreview" (click)="closePhotoPreview()"
      style="position: fixed; top: 0; left: 0; height: 100vh; width: 100vw; z-index: 999999; display: flex; align-items: center; justify-content: center; background: #000000cf;">
      <svg (click)="closePhotoPreview()"
         style="width: 20px; position: absolute; top: 30px; right: 40px; color: #fff; cursor: pointer;"
         aria-hidden="true" focusable="false" data-prefix="fas" data-icon="times"
         class="svg-inline--fa fa-times fa-w-11" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 352 512">
         <path fill="currentColor"
            d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z">
         </path>
      </svg>
      <img src="{{imgPreviewImg}}" style="width: 25vw; height: auto;background: #fff;" />
   </div>
</div>